import React from 'react';
import {
    Heading,
    Text,
    Button,
    useBreakpoint,
    Box,
    spacing,
    ProductPluginsOutlined,
    Group,
    palette,
} from '@landr/maestro';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';
import BackgroundImageFromAsset from 'components/BackgroundImageFromAsset/BackgroundImageFromAsset';
import { TwoColumns } from 'components/TwoColumns/TwoColumns';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';
import { CONFIG } from 'utils';

const InfoWrapper = styled(Box)`
    display: flex;
    height: 100%;
    max-width: 680px;
    margin: 0 auto;
    padding: ${spacing('xxl')} ${spacing('jb')};
    ${({ theme }): string => theme.breakpoint('ml')`
        padding: ${spacing('md')} ${spacing('md')} ${spacing('xxl')};
    `}
`;

const MediaWrapper = styled(Box)`
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 680px;
    margin: 0 auto;
`;

const MainWrapper = styled(Box)`
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    background-color: ${palette('neutral.900')};

    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.24);
    background: radial-gradient(
        100% 50% at 100% 0.1%,
        rgb(44, 60, 77) 0%,
        rgb(20, 39, 57) 100%
    );
`;

export const PromotionalCardChromatic = () => {
    const isTablet = useBreakpoint('ml');
    const isSmallDesktop = useBreakpoint('lg');
    const { isAuthenticated } = useAuthentication();

    const chromaticUrl = isAuthenticated
        ? `${CONFIG.VITE_PLUGINS_URL}/details/chromatic`
        : `${CONFIG.VITE_GUESTSITE_URL}/plugins/chromatic/`;

    return (
        <MainWrapper>
            <TwoColumns
                direction={isTablet ? 'column-reverse' : 'row'}
                columnRatio={isTablet ? 'full' : 'half'}
                coloredColumn="none"
            >
                <TwoColumns.Info>
                    <InfoWrapper>
                        <Group
                            direction="vertical"
                            gutter="xl"
                            display="flex"
                            alignSelf="center"
                        >
                            <Group.Item>
                                <Heading size={isSmallDesktop ? 'xl' : 'xxxl'}>
                                    Chromatic
                                </Heading>
                                <Text
                                    size={isSmallDesktop ? 'base' : 'lg'}
                                    contrast="low"
                                >
                                    <Trans>
                                        Explore new creative territories with
                                        this loop-based, playable instrument
                                        plugin. Unlimited access for Samples and
                                        Studio subscribers.
                                    </Trans>
                                </Text>
                            </Group.Item>
                            <Group.Item>
                                <Button
                                    isRounded
                                    as="a"
                                    href={chromaticUrl}
                                    target="_blank"
                                    icon={
                                        !isTablet
                                            ? ProductPluginsOutlined
                                            : undefined
                                    }
                                >
                                    <Trans>Get plugin now</Trans>
                                </Button>
                            </Group.Item>
                        </Group>
                    </InfoWrapper>
                </TwoColumns.Info>
                <TwoColumns.Media>
                    <MediaWrapper>
                        <Box
                            width="100%"
                            right="-2%"
                            paddingBottom="62.5%"
                            position="relative"
                            display="flex"
                            alignSelf="center"
                        >
                            <a href={chromaticUrl} target="_blank">
                                <BackgroundImageFromAsset
                                    image="promoCards/chromatic"
                                    filetype="png"
                                    objectFit="contain"
                                />
                            </a>
                        </Box>
                    </MediaWrapper>
                </TwoColumns.Media>
            </TwoColumns>
        </MainWrapper>
    );
};
